// Exposes jQuery as the globals the page code and vendored jQuery plugins expect
// (`$`, `jQuery`). Kept in its own module so it runs before anything else in the
// jquery-bootstrap bundle. Bootstrap 5 itself does NOT use jQuery, but the
// vendored plugins (daterangepicker, footable, metisMenu, simplebar, vmap, …)
// loaded as later <script>s do.
import $ from "jquery";

window.$ = window.jQuery = $;

export default $;
